if (!window.__siblingNavigation) {
  window.__siblingNavigation = true;

  console.log('[SiblingSelector] Initialized');

  function handleSiblingClick(e) {
    const link = e.target.closest('[data-sibling-link]');
    if (!link) return;

    e.preventDefault();
    const url = link.href;

    const productInfo = document.querySelector('product-info');
    if (!productInfo) {
      console.warn('[SiblingSelector] No product-info element found, falling back');
      window.location.href = url;
      return;
    }

    const sectionId = productInfo.dataset.section;
    const sectionsParam = [sectionId, 'sticky-atc-bar'].join(',');
    const fetchUrl = `${new URL(url).pathname}?sections=${sectionsParam}`;

    console.log('[SiblingSelector] Navigating to:', url);
    console.log('[SiblingSelector] Fetching sections:', sectionsParam);

    fetch(fetchUrl)
      .then((r) => {
        console.log('[SiblingSelector] Fetch response:', r.status, r.url);
        return r.json();
      })
      .then((data) => {
        const sectionHtml = data[sectionId];
        if (!sectionHtml) throw new Error(`Section "${sectionId}" not found in response`);

        const doc = new DOMParser().parseFromString(sectionHtml, 'text/html');
        const newProductInfo = doc.querySelector('product-info');
        if (!newProductInfo) throw new Error('product-info not found in section HTML');

        HTMLUpdateUtility.viewTransition(productInfo, newProductInfo);
        console.log('[SiblingSelector] Swapped product-info section');

        const stickyAtcHtml = data['sticky-atc-bar'];
        if (stickyAtcHtml) {
          const stickyAtc = document.getElementById('shopify-section-sticky-atc-bar');
          if (stickyAtc) {
            const stickyDoc = new DOMParser().parseFromString(stickyAtcHtml, 'text/html');
            HTMLUpdateUtility.viewTransition(stickyAtc, stickyDoc.getElementById('shopify-section-sticky-atc-bar'));
            console.log('[SiblingSelector] Swapped sticky ATC bar');
          }
        }

        history.replaceState({}, '', url);
        console.log('[SiblingSelector] Replaced history state:', url);

        bindSiblingListeners();
        console.log('[SiblingSelector] Re-bound listeners on new elements');
      })
      .catch((err) => {
        console.error('[SiblingSelector] Error, falling back to hard navigation:', err);
        window.location.href = url;
      });
  }

  function bindSiblingListeners() {
    document.querySelectorAll('[data-sibling-selector]:not([data-sibling-bound])').forEach((selector) => {
      selector.dataset.siblingBound = 'true';
      selector.addEventListener('click', handleSiblingClick);
      console.log('[SiblingSelector] Bound listener to:', selector);
    });
  }

  bindSiblingListeners();
}
